import { render, staticRenderFns } from "./singeGoods.vue?vue&type=template&id=54c2be60&scoped=true&"
import script from "./singeGoods.vue?vue&type=script&lang=js&"
export * from "./singeGoods.vue?vue&type=script&lang=js&"
import style0 from "./singeGoods.vue?vue&type=style&index=0&id=54c2be60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2be60",
  null
  
)

export default component.exports